import { Modal, TextField, Typography } from '@material-ui/core'
import styles from './styles.module.scss'
import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { sendMessageSchema } from './sendMessageSchema'
import { layoutApi } from '../../layoutApi'
import InputMask from 'react-input-mask'
import {
  useTranslation,
  useLocale,
  pushDangerNotification,
  pushSuccessNotification
} from '@plandi/common'
import { useDispatch } from 'react-redux'
import Image from 'next/image'
interface ISupport {
  open: boolean
  handleClick: () => void
}

export const SupportModal: React.FC<ISupport> = ({ open, handleClick }) => {
  const [showOr, setShowOr] = useState(true)
  const [showStepTwo, setShowStepTwo] = useState(false)

  const { data: translate } = useTranslation()
  const locale = useLocale()

  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues: {
      name: '',
      phone: '',
      email: '',
      message: ''
    },
    validationSchema: sendMessageSchema(translate, locale),
    onSubmit: (values) => {
      formik.setSubmitting(true)
      if (
        formik.values.phone.length === 0 &&
        formik.values.email.length === 0
      ) {
        dispatch(
          pushDangerNotification(
            locale === 'ru'
              ? 'Введите телефон или e-mail'
              : 'Enter phone or email'
          )
        )
        formik.setSubmitting(false)
        return
      }
      formik.setSubmitting(true)
      layoutApi
        .getSupportData(values, locale)
        .then(() => {
          formik.resetForm()
          dispatch(
            pushSuccessNotification(
              translate?.manager?.['notification-success'] ?? ''
            )
          )
          setShowStepTwo(true)
        })
        .catch(() => {
          dispatch(
            pushDangerNotification(
              translate?.manager?.['notification-error'] ?? ''
            )
          )
          formik.setSubmitting(false)
        })
    }
  })

  const handleClickClose = () => {
    formik.setSubmitting(false)
    formik.resetForm()
    handleClick()
  }

  useEffect(() => {
    if ((formik.values.phone.length || formik.values.email.length) > 0) {
      setShowOr(false)
    } else {
      setShowOr(true)
    }
  }, [formik.values.email.length, formik.values.phone.length])

  return (
    <Modal
      open={open}
      onClose={handleClick}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={styles.modal}
    >
      {showStepTwo ? (
        <div className={styles.success}>
          <button
            type="button"
            className={styles.close}
            onClick={handleClickClose}
          >
            <Image
              width={17}
              height={17}
              src="/blog/assets/closeIcon.svg"
              alt=""
            />
          </button>
          <div className={styles.logo}>
            <Image
              width={88}
              height={22}
              src="/blog/assets/plandiLogoSupport.png"
              alt=""
            />
          </div>
          <div className={styles.title}>
            {locale === 'ru'
              ? 'Благодарим за обращение!'
              : 'Thank you for reaching out!'}
          </div>
          <div className={styles.supportBg}>
            <Image
              width={277}
              height={277}
              src="/blog/assets/successSupportBg.png"
              alt=""
            />
          </div>
          <button
            type="button"
            className={styles.sendBtn}
            onClick={handleClickClose}
          >
            {locale === 'ru' ? 'вернуться на страницу' : 'return to page'}
          </button>
        </div>
      ) : (
        <form className={styles.form} onSubmit={formik.handleSubmit}>
          <button type="button" className={styles.close} onClick={handleClick}>
            <Image
              width={17}
              height={17}
              src="/blog/assets/closeIcon.svg"
              alt=""
            />
          </button>
          <div className={styles.logo}>
            <Image
              width={88}
              height={22}
              src="/blog/assets/plandiLogoSupport.png"
              alt=""
            />
          </div>
          <div className={styles.title}>
            {translate?.main?.footer?.['technical-support']?.[
              'support-title'
            ] ?? 'main.footer.technical-support.support.title'}
          </div>
          <TextField
            label={
              translate?.main?.footer?.['technical-support']?.[
                'support-name'
              ] ?? 'technical-support'
            }
            type="text"
            fullWidth
            variant="outlined"
            margin="normal"
            name="name"
            className={styles.input}
            onChange={formik.handleChange}
            value={formik.values.name ?? ''}
            onBlur={formik.handleBlur('name')}
            error={Boolean(formik.errors.name) && formik.touched.name}
            helperText={
              formik.errors.name && formik.touched.name
                ? formik.errors.name
                : ' '
            }
            disabled={formik.isSubmitting}
          />
          <div style={{ position: 'relative' }}>
            <InputMask
              mask="+9 (999) 999 99 99"
              value={formik.values.phone}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur('phone')}
              disabled={formik.isSubmitting || formik.values.email.length > 0}
            >
              {() => (
                <TextField
                  name="phone"
                  onChange={formik.handleChange}
                  value={formik.values.phone}
                  margin="normal"
                  variant="outlined"
                  fullWidth
                  disabled={
                    formik.isSubmitting || formik.values.email.length > 0
                  }
                  label={
                    translate?.['job-site']?.profile?.phone ?? 'Номер телефона'
                  }
                  error={
                    Boolean(formik.errors.phone) &&
                    formik.touched.phone &&
                    formik.values.phone.length !== 0
                  }
                  helperText={
                    formik.errors.phone &&
                    formik.touched.phone &&
                    formik.values.phone.length !== 0
                      ? formik.errors.phone
                      : ' '
                  }
                />
              )}
            </InputMask>
            {showOr && (
              <Typography variant="body2" className={styles.or}>
                {locale === 'ru' ? 'или' : 'or'}
              </Typography>
            )}
            <TextField
              name="email"
              value={formik.values.email ?? ''}
              onChange={formik.handleChange}
              fullWidth
              margin="normal"
              label="e-mail"
              variant="outlined"
              onBlur={formik.handleBlur('email')}
              error={Boolean(formik.errors.email) && formik.touched.email}
              helperText={
                formik.errors.email && formik.touched.email
                  ? formik.errors.email
                  : ' '
              }
              disabled={formik.isSubmitting || formik.values.phone.length > 0}
            />
          </div>
          <TextField
            label={
              translate?.main?.footer?.['technical-support']?.[
                'support-desc'
              ] ?? ''
            }
            type="text"
            fullWidth
            variant="outlined"
            margin="normal"
            name="message"
            multiline
            minRows={4}
            onChange={formik.handleChange}
            value={formik.values.message ?? ''}
            onBlur={formik.handleBlur('message')}
            error={Boolean(formik.errors.message) && formik.touched.message}
            helperText={
              formik.errors.message && formik.touched.message
                ? formik.errors.message
                : ' '
            }
            disabled={formik.isSubmitting}
          />
          <button
            className={styles.sendBtn}
            type="submit"
            disabled={formik.isSubmitting}
          >
            {translate?.main?.footer?.['technical-support']?.['support-button']}
          </button>
        </form>
      )}
    </Modal>
  )
}
